<template>
  <v-layout row wrap class="pa-5 pb-4">
  <v-flex xs12 sm12>
    <div>
    <!-- <v-btn color="primary" dark @click.stop="openModal = !openModal">Modificar... </v-btn> -->
    <!-- <v-dialog v-model="openModal" max-width="400"> -->
      <v-card>
        <v-card-title class="subheading"></v-card-title>
        <v-card-text class="title">Selecione a cor que deseja para o card da <br>
             Unidade de atendimento que será exibido na tela da Atendente</v-card-text>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-layout row></v-layout>
              <v-flex class="center" xs12 sm3>
                <v-layout row>
                  <v-flex xs1>
                    <!--<v-checkbox
                      class="shrink"
                      @change="showColorPicker = !showColorPicker"
                      v-model="checkboxEnabled"
                      dark
                    ></v-checkbox>-->
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field disabled v-model="textColorHex" label="cor atual"/>
                  </v-flex>
                  <v-flex xs3>

                    <ColorPickerButton
                      v-bind:field-name="'alertTextColor'"
                      v-bind:init-color="alertTextColor"
                      v-on:update-color="getUpdatedColor"
                      v-bind:show-picker-container="showColorPicker"
                    ></ColorPickerButton>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
          </v-form>

           <v-btn :disabled=!textColorHex color="primary" dark @click.stop="alterarCor">Salvar</v-btn>
           <v-btn :disabled=!textColorHex  @click="$router.go(-1)"><v-icon dark left>arrow_back</v-icon>Voltar</v-btn>
           <v-alert
          :value="sucesso"
          color="success"
          icon="check_circle"
          outlined
        >
          Sucesso ao alterar a cor!
        </v-alert>
        </v-card-text>

      </v-card>
    <!-- </v-dialog> -->
  </div>
    </v-flex>
    </v-layout>

</template>

<script>
import ColorPickerButton from './ColorPickerButton'
// import TabelaFuncionarios from "./../TabelaFuncionarios";
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'HelloWorld',
  data () {
    return {
      openModal: false,
      sucesso: false,
      respostaServidor: '',
      alertTextColor: '',
      showColorPicker: true,
      textColorHex: '',
      checkboxEnabled: false
    }
  },
  props: {
    msg: String
  },
  components: {
    ColorPickerButton
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    this.respostaServidor = ''
    this.retornarCor()
  },
  methods: {
    getUpdatedColor (colorValue, fieldName) {
      this.textColorHex = colorValue
    },

    retornarCor () {
      console.log('em retornarCor')

      administradorUnidadeService.administradorUnidade
        .retornarCor()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data.cor)
          if (rsp.status == 200) {
            console.log('setou...')

            this.alertTextColor = rsp.data.cor
            this.textColorHex = rsp.data.cor
          }

          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          this.erroEditar = true
          // handle your error here
          console.log(err)
        })
    },

    alterarCor () {
      this.sucesso = false
      administradorUnidadeService.administradorUnidade
        .alterarCor(this.textColorHex)
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          if (rsp.data == true) {
            this.respostaServidor = 'Cor editada com sucesso !!'
            // this.sucessoEditar = true
            this.sucesso = true
          }
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          this.erroEditar = true
          // handle your error here
          console.log(err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.color-picker-outer {
  width: 30px;
  height: 30px;
  display: inline-block;
  background-color: #EEE;
  position: relative;
  top: 19px;
  outlined: 3px solid #C9C9C9;
}

.color-picker-inner {
  width: 30px;
  height: 30px;
  position: relative;
  display: inline-block;
}

.vc-chrome {
  position: absolute;
  top: -3px;
  right: 33px;
  z-index: 9;
}
</style>
